import React, { useState } from 'react';
import { PLANS } from './landingData';
import { LEADS_SCRIPT_URL } from './landingConfig';

const EMPTY = { name: '', clinic: '', email: '', phone: '', plan: '', message: '' };

// Aviso por email vía Google Apps Script (ver docs/landing-apps-script/).
// El lead ya quedó en Firestore: si el aviso falla, no se muestra error.
function notifyLead(form) {
  if (!LEADS_SCRIPT_URL) return;
  fetch(LEADS_SCRIPT_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify({ ...form, source: 'medix.cl' }),
    keepalive: true,
  }).catch((err) => console.error('Aviso de lead no enviado', err));
}

const ContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      // Firebase se carga recién al enviar, para que la landing sea liviana.
      const [{ addDoc, collection, serverTimestamp }, { db }] = await Promise.all([
        import('firebase/firestore'),
        import('../../config/firebase'),
      ]);
      await addDoc(collection(db, 'leads'), {
        ...form,
        source: 'medix.cl',
        createdAt: serverTimestamp(),
      });
      notifyLead(form);
      setForm(EMPTY);
      setStatus('sent');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <div className="lp-form-done">
        <h3>¡Gracias!</h3>
        <p>Recibimos tus datos. Te contactaremos dentro de las próximas 24 horas hábiles.</p>
        <button type="button" className="lp-btn lp-btn-ghost" onClick={() => setStatus('idle')}>
          Enviar otra solicitud
        </button>
      </div>
    );
  }

  return (
    <form className="lp-contact-form" onSubmit={submit}>
      <label>
        Nombre
        <input required maxLength={100} value={form.name} onChange={update('name')} autoComplete="name" />
      </label>
      <label>
        Clínica o consulta
        <input maxLength={100} value={form.clinic} onChange={update('clinic')} autoComplete="organization" />
      </label>
      <label>
        Email
        <input required type="email" maxLength={150} value={form.email} onChange={update('email')} autoComplete="email" />
      </label>
      <label>
        Teléfono
        <input type="tel" maxLength={30} value={form.phone} onChange={update('phone')} autoComplete="tel" placeholder="+56 9 ..." />
      </label>
      <label className="lp-full">
        Plan de interés
        <select value={form.plan} onChange={update('plan')}>
          <option value="">Aún no lo sé</option>
          {PLANS.map((p) => (
            <option key={p.name} value={p.name}>{p.name}</option>
          ))}
        </select>
      </label>
      <label className="lp-full">
        Mensaje
        <textarea rows={4} maxLength={2000} value={form.message} onChange={update('message')} placeholder="Cuéntanos sobre tu clínica: especialidad, cuántos profesionales, qué usan hoy..." />
      </label>
      {status === 'error' && (
        <p className="lp-form-error lp-full">No pudimos enviar el formulario. Intenta de nuevo o escríbenos por WhatsApp.</p>
      )}
      <button type="submit" className="lp-btn lp-btn-primary lp-full" disabled={status === 'sending'}>
        {status === 'sending' ? 'Enviando…' : 'Solicitar piloto'}
      </button>
      <p className="lp-form-legal lp-full">
        Al enviar aceptas que te contactemos según nuestra <a href="/privacidad">Política de privacidad</a>.
      </p>
    </form>
  );
};

export default ContactForm;
